<template lang="pug">
    .cash-reports
        .cash-flow-log.is-reported.reported-header(v-for="el in cashReports")
            hr
            .row
                .direction.highlight
                    i.report.fas.el-icon-fa-check
                //- .amount {{ $t('Cash Report') }} \#{{ el.id }}
                .amount
                    template(v-if="el.is !== el.should")
                        | {{ el.is | moneyFormat(el.currency_code) }}
                        | / {{ el.should | moneyFormat(el.currency_code) }}
                    template(v-else)
                        | {{ el.is | moneyFormat(el.currency_code) }}
                a.report.highlight(
                    v-if="cashReport.file"
                    href
                    :disabled="printing"
                    @click.stop.prevent="print"
                ) {{ $t('Print Cash Report \#{id}', { id: el.id }) }}
                .report.gray(v-else) {{ $t('Cash Report') }} \#{{ el.id }}
                .at {{ el.created_at | timestamp2date($t('yyyy-MM-dd') + ', HH:mm') }}
            .row
                .by
                    template(v-if="el.administrator_name") {{ el.administrator_name }}
                .comment
                    template(v-if="el.comment") {{ el.comment }}
</template>

<i18n>
{
    "en": {
        "Print Cash Report #{id}": "Print Cash Report #{id}",
        "Print Cash Report \\#{id}": "Print Cash Report \\#{id}"
    },
    "de": {
        "Print Cash Report #{id}": "Kassenabschluss #{id} drucken",
        "Cash Report": "Kassenabschluss",
        "Could not print the cash report PDF!": "Kassenabschluss PDF konnte nicht gedruckt werden!"
    }
}
</i18n>

<script>
import printJS from 'print-js-updated';
import { moneyFormat, timestamp2date } from '@/filters'

import AuthApi from '@/store/api/system/auth';

export default {
    name: 'CashFlowLogReportRows',
    props: {
        cashReport: {
            type: Object,
            required: true,
        },
        cashFlowLogs: {
            type: Array,
            required: true,
        }
    },
    data: () => ({
        printing: false
    }),
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        cashReports() {
            // return this.cashFlowLogs.filter((el, i, a) => {
            //     return el.cashReport && el.cashReport.uuid === this.cashReport.uuid
            //         // unique filter
            //         && a.findIndex(log => log.cashReport && log.cashReport.id === el.cashReport.id) === i
            // }).map(el => el.cashReport)

            const relatedCashReports = this.cashReport.relatedCashReports || []
            return [
                this.cashReport,
                ...relatedCashReports.filter(el => el.payment_method_id == this.cashReport.payment_method_id)
            ]
        }
    },
    methods: {
        print(e) {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PRIVATE_STORAGE_ROUTE}`, '/')
            let table = 'files'

            const file = this.cashReport.file
            const token = AuthApi.getToken()
            const printable = `${storageRoute}/${table}/${file.id}/${file.name}?token=${token}`

            printJS({
                printable,
                onLoadingEnd: () => {
                    // Don't reset state here - wait for print dialog
                },
                onError: () => {
                    this.printing = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Could not print the cash report PDF!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                },
                onPrintDialogClose: () => {
                    this.printing = false;
                }
            })
        }
    }
}
</script>

<style lang="sass" scoped>
.cash-flow-log
    flex-grow: 1
    .in
        color: $--color-success
    .out
        color: $--color-danger
    .row
        display: flex
        gap: 0.5rem
        span + span:before
            content: ' '
        .amount, .by
            flex-grow: 1
        & + .row
            margin-top: 0.5rem
        .gray
            color: $color-grey-text
.reported-header i
    color: $--shop-color-primary
hr
    flex-grow: 1
    opacity: 0.5
    width: 100%

.is-reported .row > *:not(.highlight)
    opacity: 0.5
</style>
